import { usePageNation } from './hooks';

type Props = {
  /** 総ページ数。 */
  totalPages: number;
  /** 現在のページ。 */
  currentPageState: number;
  /** 現在のページを設定するイベント。 */
  setCurrentPageState: (page: number) => void;
};

/** ページネーションのコンポーネント */
export const PageNation = ({
  totalPages,
  currentPageState,
  setCurrentPageState,
}: Props) => {
  const {
    pageNumbers,
    handleClickNextPage,
    handleClickPreviousPage,
    handleClickPageNumber,
  } = usePageNation({
    totalPages,
    currentPageState,
    setCurrentPageState,
  });

  if (1 >= totalPages) {
    return <></>;
  }

  return (
    <div className="flex items-center justify-center space-x-[16px]">
      {currentPageState > 1 && (
        <OutlineButton onClick={handleClickPreviousPage}>
          <ChevronLeftIcon />
        </OutlineButton>
      )}
      {pageNumbers.map((number, index) =>
        number === '...' ? (
          <span key={`ellipsis-${index}`} className="text-textSecondary">
            ...
          </span>
        ) : (
          <OutlineButton
            key={number}
            onClick={() => handleClickPageNumber(number)}
            isCurrentPageNumber={number === currentPageState}
          >
            <p>{number}</p>
          </OutlineButton>
        )
      )}
      {totalPages > currentPageState && (
        <OutlineButton onClick={handleClickNextPage}>
          <ChevronRightIcon />
        </OutlineButton>
      )}
    </div>
  );
};

type OutlineButtonProps = {
  /** ボタンの子要素。 */
  children: React.ReactNode;
  /** ボタンクリック時のイベント。 */
  onClick: VoidFunction;
  /** 現在のページ番号かどうか。 */
  isCurrentPageNumber?: boolean;
};

const OutlineButton = ({
  children,
  onClick: handleClick,
  isCurrentPageNumber = false,
}: OutlineButtonProps) => {
  return (
    <button
      className={`
        w-[32px] h-[32px] flex items-center justify-center rounded-full border border-outline inter-regular
        ${isCurrentPageNumber ? 'bg-primary text-surface' : 'bg-surface text-textSecondary'}
      `}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

const ChevronLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 19.5 8.25 12l7.5-7.5"
        stroke="#858688"
      />
    </svg>
  );
};

const ChevronRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.25 4.5 7.5 7.5-7.5 7.5"
        stroke="#858688"
      />
    </svg>
  );
};
